import type { IInterpolateService } from "angular";

import { isEmpty, remove, uniq, uniqWith } from "lodash";

import "angular-translate";

export function SplitFilter() {
    return (input: string, delimiter?: RegExp) => {
        const delimiter2 = delimiter || new RegExp("[\\r\\n]+");
        return input.split(delimiter2);
    };
}

export function NewLinesFilter() {
    return (input: string, delimiter?: RegExp) => {
        const delimiter2 = delimiter || new RegExp("[\\r\\n]+");
        return input.replace(delimiter2, "<br>");
    };
}

export function InterpolateFilter($interpolate: IInterpolateService) {
    return (template: string, myObject?: any) => {
        const exp = $interpolate(template);
        return exp(myObject);
    };
}

export function JoinFilter() {
    return (input: string[], delimiter?: string) => {
        return (input || ([] as string[])).filter((t) => !!t).join(delimiter || ", ");
    };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function UniqueFilter<T>() {
    return (arr: any[], field: string) => {
        if (field) {
            return uniqWith(arr, (a: any) => a[field]);
        }
        return uniq(arr);
    };
}

export function PageTitleFilter() {
    return (input: string, delimiter: string) => {
        if (input && delimiter) {
            const wordsArr = input.split(delimiter);
            const loadingIndex = wordsArr.findIndex(isEmpty);
            wordsArr[0] = "Irisity Manage Portal";
            if (loadingIndex !== -1) {
                wordsArr[loadingIndex] = "Loading...";
            }
            remove(wordsArr, isEmpty);
            return wordsArr.reverse().join(delimiter);
        }
        return input;
    };
}

export function HighlightTextFilter() {
    return (input: string, text: string) => {
        if (!input || !text) {
            return input;
        }

        const escaped = text.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        const pattern = new RegExp(escaped, "gi");

        return input.replace(pattern, `<b class="highlight">$&</b>`);
    };
}
